<template>
	<div class="copyright layout-row layout-hv-center color-white bg-pink1">
		Copyright © 2018 社團法人臺灣童心創意行動協會 | All Rights Reserved.
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	computed: {},
	methods: {},
	created() { },
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.copyright {
	min-width: 1000px;
	font-size: 12px;
	padding: 18px 0;
}
</style>